import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IProduct } from './models/product.model';

@Injectable({
  providedIn: 'root'
})
export class ProductListService {
  private parentProductList: IProduct[] = [];
  private parentProductList$: BehaviorSubject<IProduct[]> = new BehaviorSubject<IProduct[]>([]);

  getParentProductList$() {
    return this.parentProductList$.asObservable();
  }

  getParentProductList(): IProduct[] {
    return this.parentProductList;
  }

  /** Set via Venue-Config, shouldn't need to reset this */
  setProductList(products: IProduct[]): void {
    this.parentProductList = products;
    this.parentProductList$.next(products);
  }
}
